import { GraduationCap } from 'lucide-react';
import { cn } from '../lib/cn';

type Props = {
  /** "piccolo" per le card dell'elenco, "normale" per la scheda. */
  misura?: 'piccolo' | 'normale';
};

/**
 * Il badge dei clienti che si sono iscritti ad almeno un corso. Viola perche'
 * nel gestionale giallo, verde e rosso dicono gia' altro (avviso, conferma,
 * inattivo).
 */
export function BadgeCorsista({ misura = 'normale' }: Props) {
  return (
    <span
      className={cn(
        'inline-flex flex-shrink-0 items-center gap-1 rounded-full bg-violet-100 font-medium uppercase text-violet-700',
        misura === 'piccolo' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs',
      )}
    >
      <GraduationCap className={misura === 'piccolo' ? 'h-3 w-3' : 'h-3.5 w-3.5'} aria-hidden="true" />
      corsista
    </span>
  );
}
